import { format } from 'date-fns'

export function formatDate(local_start_date, local_start_time) {
  return format(Date.parse(`${local_start_date}T${local_start_time}`), 'MMM d')
}

export function formatYear(local_start_date, local_start_time) {
  return format(Date.parse(`${local_start_date}T${local_start_time}`), 'yyyy')
}
